import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/pl/personaFi/agent")({
  beforeLoad: () => {
    throw redirect({ to: "/pl/agent", replace: true });
  },
});
